import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import Loader from "../Chargers/Loader";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import ReactPaginate from 'react-paginate'; 
import $ from 'jquery';
import Select from 'react-select';
import ReactDOM from 'react-dom';  
import { fetchStatusList } from "../../Apis/StatusListing";
import { useNavigate } from "react-router-dom";



function Payments() {
  document.title = "Payment";
  const [StationData, setStationData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [totalCount, setTotalCount] = useState(0);
  const [selectedLimit, setselectedLimit] = useState("");
  const [Limit, setLimit] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedChargers, setSelectedChargers] = useState([]);
  const [ChargerData, setChargerData] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [TotalPayments, setTotalPayments] = useState("");

  let navigate = useNavigate();
  

  const customSelectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',            // Ensure the select box takes the full width of the container
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,             // Ensure the dropdown appears above other elements
    }),
    control: (provided) => ({
      ...provided,
      minHeight: '40px',        // Ensure the control area is tall enough for visibility
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',       // Limit the height for selected values
      overflowY: 'auto',        // Add scroll if too many values are selected
    }),
  };
  

 



  
  
  // Helper function for handling the select box change
 
  
   console.log("selecgtedchargers", selectedChargers);
   console.log("selectedChargers", selectedChargers);


  
 
 
  
  
  



 

 





  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  // Fetch Stations Data without search filter
  const FetchStationsData = async (currentPage, searchTerm = '') => {
    setLoading(true);
    const url = `${BaseURL}/payment/?page=${page}&searchText=${searchTerm}&payment_status=${selectedStatus}`;

    try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      if (res && res.data.data) {
        setStationData(res.data.data);
        setFilteredData(res.data.data);
        setTotalCount(res.data?.totalCount || 0);
        setLimit(res?.data?.limit);
        setPageCount(Math.ceil(res.data.totalCount / res?.data?.limit));
        setTotalPayments(res?.data?.totalAmount);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchStationsData(page, searchQuery); // Pass current page and search query to the fetch function
  }, [page,]); 

  // Handle input change in search field
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleReset = (event) => {
    event.preventDefault();
   navigate(`/payments`);
    };
  

console.log("ChargerData", ChargerData);

  // Handle submit to fetch filtered data
  const handleSearchSubmit = async (e) => {
    setPage(1);
    e.preventDefault(); // Prevent default form submission
  
    // Check if the search query is empty
    if (!searchQuery.trim()) {
      // If no search query, call FetchStationsData to fetch all stations
      await FetchStationsData(page); // Ensure this function fetches all stations
      return; // Exit the function early
    }
  
    setLoading(true); // Set loading state to true while fetching
  
    const url = `${BaseURL}/payment?page=${page}&searchText=${searchQuery}&payment_status=${selectedStatus}`;
  
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`, // Include the authorization token
        },
      });
  
      if (res && res.data && res.data.data) {
        setFilteredData(res.data.data); 
        setTotalCount(res.data.data.length); // Update totalCount with filtered data count
        setPageCount(Math.ceil(res?.data?.totalCount / res?.data?.limit)); // Update page count based on total count and limit
      } else {
        setFilteredData([]); // If no data is returned, set filtered data to empty
        setTotalCount(0); // Update total count to 0 when no data is found
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false); // Set loading state to false after fetching
    }
  };

  const handleStatusType = async (event, userId) => {
    const status = event.target.value;

    // Update local state
    setUserStatuses((prevStatuses) => ({
      ...prevStatuses,
      [userId]: status,
    }));

    const url = `${BaseURL}/station/changestatus/${userId}`;

    const statusData = { status };

    try {
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {

      console.error("Error updating status:", error);
    }
  };

  const fetchStatusListing = async () => {
    const apiEndpoint = `${BaseURL}/settings/charger/status`;

    setLoading(true);

    var url = apiEndpoint

    let res = await request({
      url: url,
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);
   
    if (res && res.data) {
      setStatusListing(res.data);
      }

    return [];
  };
  useEffect(() => {
    fetchStatusListing();
  }, []);
console.log("StationData", StationData);
console.log("statuslisting", statusListing);
console.log("Limit", Limit);
const handleStatus = (e) => {
  setSelectedStatus(e.target.value);
}
console.log("selectedchargers", selectedChargers);
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header pb-0">
            <div className="row">
            <div className="col-12 col-md-4 mb-3 d-flex justify-content-start align-items-center" style={{}}>

  {/*  */}

</div>
{/* <div className="col-12 col-md-4 mb-3 d-flex justify-content-start align-items-center" style={{ }}> */}

{/*  */}
{/* <button className="btn btn-primary" style={{ padding: "8px 12px" }}>
  Total Payment: {TotalPayments}
</button> */}
{/* </div> */}
</div>


  <div className="row align-items-center">
    <div className="col-6 d-flex align-items-center" style={{ gap: "10px" }}>
      <h5 className="mb-0">All Payments ({totalCount ? totalCount : "Loading..."})</h5>
      <button className="btn btn-success" style={{ height: "38px", borderRadius: "34px" }}>
        Total Payment : {TotalPayments}
      </button>
    </div>
    <div className="col-6 d-flex justify-content-end align-items-center" style={{ gap: "10px" }}>
      <form 
        onSubmit={handleSearchSubmit} 
        className="d-flex align-items-center" 
        style={{ width: "auto" }}
      >
        <input
          placeholder="Find Data Here"
          className="form-control"
          style={{
            width: "100%",
            maxWidth: "170px",
            border: "1px solid black",
            borderRadius: "34px",
            height: "38px",
          }}
          value={searchQuery}
          onChange={handleSearchChange}
        />
        <select
          className="form-control"
          style={{
            width: "100%",
            maxWidth: "150px",
            border: "1px solid black",
            borderRadius: "34px",
            height: "38px",
          }}
          onChange={handleStatus}
        >
          <option value="">Select Status</option>
          <option value="Pending">Pending</option>
          <option value="Success">Success</option>
          <option value="Refunded">Refunded</option>
          <option value="Failed">Failed</option>
        </select>
        <button
          type="submit"
          className="btn btn-primary"
          style={{
            height: "38px",
            padding: "0 20px",
            borderRadius: "34px",
          }}
        >
          Search
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          style={{
            height: "38px",
            padding: "0 20px",
            borderRadius: "34px",
          }}
          onClick={handleReset}
        >
          Reset
        </button>
      </form>
    </div>
  </div>
  <hr />
   </div>
            <div className="card-body">
              {loading ? (
                <Loader />
              ) : (
                <div className="card-body" style={{ marginLeft: "-19px" }}>
                {loading ? (
                  <Loader /> 
                ) : (
                  <>
                    <div className="table-responsive">
                      
                    <table className="display dataTable" id="advance-1">
  <thead>
    <tr>
      <th>Sr. No</th>
       <th>User Name</th>
 <th>Mobile No.</th>
                        <th>Order ID</th>
                        <th>Amount</th>
                        <th>Payment Status</th>
                        <th>Payment Status Type</th>
                       <th>Created Date</th>
                    </tr>
  </thead>
  <tbody>
    {filteredData?.length === 0 ? (
    <tr>
    <td colSpan="8" className="text-center">
       <h4>No data Found</h4>  {/* Assuming Loader is a React component */}
    </td>
  </tr>
  
    ) : (
      filteredData?.map((u, index) => (
        <tr key={index}>
          
          <td>{(page - 1) * Limit + index + 1}</td>
                             <td>{u?.name}</td>
                            <td>{u?.mobile}</td>
                            <td>{u?.order_id}</td>
                            <td>{u?.amount}</td>
                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
  {u?.payment_status === 'Success' ? (
    <button className="btn btn-success" style={{ width: '74px', padding: '5px', fontSize: '12px' }}>Success</button>
  ) : u?.payment_status === 'Failed' ? (
    <button className="btn btn-danger" style={{ width: '74px', padding: '5px', fontSize: '12px' }}>Failed</button>
  )  : u?.payment_status === 'Pending' ? (
    <button className="btn"  style={{ width: '74px', padding: '5px', fontSize: '12px', backgroundColor: "Yellow", color: "black" }}>Pending</button>
  ) : ""
}
</td>
                            <td>{u?.payment_type_text}</td>
                            <td>{u?.createdAt}</td>
        </tr>
      ))
    )}
  </tbody>
</table>

                    </div>

                    <div className="pagination-container mt-4">
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        forcePage={page - 1} 
                      />
                    </div>
                  </>
                )}
              </div>
                
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payments;
